export enum AuthorityMaterial {
  MOVIMENTATION_MATERIAL_RETURN_MATERIAL = '2.5.3',
  MOVIMENTATION_MATERIAL_DELIVER_MATERIAL = '2.5.2',
  MOVIMENTATION_MATERIAL_VIEW = '2.5.1',
  MOVIMENTATION_MATERIAL_DELIVERY_OF_MATERIALS = '2.5',
}
